import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router";
import LanguageSelection from "../../components/LanguageSelection/LanguageSelection";
import { logOut } from "../../store/slices/auth/authSlice";
import "./Navbar.scss";
import { setIgnoreMobile } from "../../store/slices/appTitanSlice";

const DashboardNavbar = () => {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  return (
    <nav
      className="navbar sticky-top flex-md-nowrap shadow navbar-expand-lg"
      id="dashboard-navigation"
    >
      <div className="container-fluid p-0">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item navbar-text">
              <Nav.Link as={Link} to="/application">
                {t("navigation.CalculationTool")}
              </Nav.Link>
            </li>
            <li className="nav-item navbar-text">
              <Nav.Link as="span">
                <LanguageSelection />
              </Nav.Link>
            </li>
            <li className="nav-item navbar-text">
              <Nav.Link
                as={Link}
                to="/"
                onClick={() => {
                  dispatch(setIgnoreMobile(false));
                  dispatch(logOut());
                }}
              >
                {t("navbar.logout")}
              </Nav.Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default DashboardNavbar;
